/** Ticket #3130: 9 national digits after +221, prefixes 70, 71, 75, 76, 77, 78. */
const SENEGAL_MOBILE_RE = /^(?:70|71|75|76|77|78)\d{7}$/;

/**
 * Normalize pasted or legacy phone input to national 9 digits (or empty string).
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeSenegalPhoneInput(raw) {
  if (raw === undefined || raw === null) return "";
  let digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";

  if (digits.length === 12 && digits.startsWith("221")) {
    digits = digits.slice(3);
  } else if (digits.length > 9 && digits.startsWith("221")) {
    digits = digits.slice(-9);
  }

  if (digits.length === 10 && digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  if (digits.length > 9) {
    digits = digits.slice(-9);
  }

  return digits;
}

/**
 * @param {string} nineDigits - digits only, no country code
 * @param {(key: string, fallback: string) => string} [t] - i18n translate
 * @returns {string|null} error message or null if valid
 */
export function validateSenegalPhoneNineDigits(nineDigits, t) {
  const tr = (key, fallback) => (t ? t(key, fallback) : fallback);
  const normalized = normalizeSenegalPhoneInput(nineDigits);

  if (!normalized) {
    return tr("admin.annotators.modals.validation.phoneRequired", "Phone number is required");
  }
  if (!/^\d{9}$/.test(normalized)) {
    return tr("admin.annotators.modals.validation.phoneInvalid", "Phone must be a 9-digit number");
  }
  if (!SENEGAL_MOBILE_RE.test(normalized)) {
    return tr(
      "admin.annotators.modals.validation.phoneSenegalMobile",
      "Invalid Senegalese mobile number. Use 9 digits starting with 70, 71, 75, 76, 77, or 78."
    );
  }
  return null;
}
